export const OrderProductsGroupHeaderItems = ({ children }: React.PropsWithChildren) => {
  return <div className="flex items-end justify-between gap-3 sm:gap-5">{children}</div>;
};
